// extracted by mini-css-extract-plugin
export var container = "_bf-0";
export var containerTopRight = "_bf-1";